import { Util } from '@/modules/util'

const isArray = (val: any) => Object.prototype.toString.call(val).indexOf('Array') > -1
const isObject = (val: any) => Object.prototype.toString.call(val).indexOf('Object') > -1

const formatKeys = function (data: any, formatter: (key: string) => string): any {
  if (isArray(data)) {
    return data.map((item: any) => {
      return formatKeys(item, formatter)
    })
  } else if (isObject(data)) {
    const n: any = {}
    for (const k in data) {
      let formattedKey = formatter(k).replace(/_([0-9])/g, '$1') // Remove underscore before numbers
      n[formattedKey] = formatKeys((data as any)[k], formatter)
    }
    return n
  }
  return data
}

const keysToCamel = (data: any) => formatKeys(data, Util.Str.snakeToCamel)
const keysToSnake = (data: any) => formatKeys(data, Util.Str.camelToSnake)

export const Obj = {
  keysToCamel,
  keysToSnake
}
